import React, { useState } from 'react';
import './FileStorageDemo.css';
import efsIcon from './amazon-elastic-file-system.svg';

const awsOrange = '#FF9900';

const folders = ['/home', '/var', '/data', '/shared'];
const randomFile = () => {
  const names = ['notes.txt', 'index.html', 'script.js', 'report.docx', 'image.png'];
  const name = names[Math.floor(Math.random() * names.length)];
  return name;
};

const FileStorageDemo: React.FC = () => {
  const [files, setFiles] = useState<{ folder: string; name: string }[]>([]);

  const handleAddFile = () => {
    const folder = folders[Math.floor(Math.random() * folders.length)];
    setFiles([...files, { folder, name: randomFile() }]);
  };

  return (
    <div className="file-demo-container wide">
      <div className="file-demo-header">
        <img src={efsIcon} alt="AWS EFS Icon" className="aws-efs-icon" />
        <h2 className="file-demo-title">EFS File Storage</h2>
      </div>
      <div className="file-demo-desc">
        File storage organizes data in folders and files, supporting shared access and collaboration. Ideal for web servers and shared environments.
      </div>
      <div className="file-demo-tree">
        {folders.map(folder => (
          <div className="file-demo-folder" key={folder}>
            <div className="file-demo-folder-name">{folder}</div>
            <div className="file-demo-files">
              {files.filter(f => f.folder === folder).map((f, i) => (
                <div className="file-demo-file" key={f.name + i}>{f.name}</div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <button className="file-demo-add" onClick={handleAddFile}>Add File</button>
    </div>
  );
};

export default FileStorageDemo; 